import BaseService from '@/api/services/index'

export default class StageService extends BaseService {
    public async getStageConnection (): Promise<string> {
        return this.api.get<never, string>(
            this.getUrl('get_stage_connection')
        )
    }
}
